import { animate, style, transition, trigger } from '@angular/animations';

import { CURVA_ANIMACAO, CURVA_MOLA_ANIMACAO } from './chat.constantes';

export const animacaoExpandir = trigger('expandir', [
  transition(':enter', [
    style({ height: 0, opacity: 0, overflow: 'hidden', paddingTop: 0, paddingBottom: 0 }),
    animate(`220ms ${CURVA_ANIMACAO}`, style({ height: '*', opacity: 1, paddingTop: '*', paddingBottom: '*' }))
  ]),
  transition(':leave', [
    style({ overflow: 'hidden' }),
    animate(`180ms ${CURVA_ANIMACAO}`, style({ height: 0, opacity: 0, paddingTop: 0, paddingBottom: 0 }))
  ])
]);

export const animacaoSurgir = trigger('surgir', [
  transition(':enter', [
    style({ opacity: 0, transform: 'scale(0.92)' }),
    animate(`160ms ${CURVA_ANIMACAO}`, style({ opacity: 1, transform: 'scale(1)' }))
  ]),
  transition(':leave', [
    animate(`120ms ${CURVA_ANIMACAO}`, style({ opacity: 0, transform: 'scale(0.92)' }))
  ])
]);

export const animacaoPop = trigger('pop', [
  transition(':enter', [
    style({ opacity: 0, transform: 'translateY(6px) scale(0.85)' }),
    animate(`220ms ${CURVA_MOLA_ANIMACAO}`, style({ opacity: 1, transform: 'none' }))
  ]),
  transition(':leave', [
    animate(`140ms ${CURVA_ANIMACAO}`, style({ opacity: 0, transform: 'translateY(4px) scale(0.9)' }))
  ])
]);

export const animacaoSubir = trigger('subir', [
  transition(':enter', [
    style({ opacity: 0, transform: 'translateY(8px)' }),
    animate(`180ms ${CURVA_ANIMACAO}`, style({ opacity: 1, transform: 'none' }))
  ]),
  transition(':leave', [
    animate(`140ms ${CURVA_ANIMACAO}`, style({ opacity: 0, transform: 'translateY(8px)' }))
  ])
]);

export const animacaoFade = trigger('fade', [
  transition(':enter', [
    style({ opacity: 0 }),
    animate(`150ms ease`, style({ opacity: 1 }))
  ]),
  transition(':leave', [
    animate(`120ms ease`, style({ opacity: 0 }))
  ])
]);

export const animacaoItemLista = trigger('itemLista', [
  transition(':enter', [
    style({ opacity: 0, transform: 'translateY(6px)' }),
    animate(`240ms ${CURVA_ANIMACAO}`, style({ opacity: 1, transform: 'none' }))
  ]),
  transition(':leave', [
    style({ overflow: 'hidden' }),
    animate(`200ms ${CURVA_ANIMACAO}`, style({ opacity: 0, height: 0, paddingTop: 0, paddingBottom: 0 }))
  ])
]);

export const animacaoDeslizar = trigger('deslizar', [
  transition(':enter', [
    style({ transform: 'translateX(100%)' }),
    animate(`260ms ${CURVA_ANIMACAO}`, style({ transform: 'translateX(0)' }))
  ]),
  transition(':leave', [
    animate(`200ms ${CURVA_ANIMACAO}`, style({ transform: 'translateX(100%)' }))
  ])
]);

export const animacaoRevelar = trigger('revelar', [
  transition(':enter', [
    style({ width: 0, opacity: 0, transform: 'translateX(-6px)', overflow: 'hidden' }),
    animate(`260ms ${CURVA_ANIMACAO}`, style({ width: '*', opacity: 1, transform: 'none' }))
  ]),
  transition(':leave', [
    style({ overflow: 'hidden' }),
    animate(`200ms ${CURVA_ANIMACAO}`, style({ width: 0, opacity: 0, transform: 'translateX(-6px)' }))
  ])
]);

export const animacaoSurgirHistorico = trigger('surgirHistorico', [
  transition(':enter', [
    style({ opacity: 0, transform: 'translateY(6px)' }),
    animate(`220ms ${CURVA_ANIMACAO}`, style({ opacity: 1, transform: 'none' }))
  ]),
  transition(':leave', [
    animate(`140ms ${CURVA_ANIMACAO}`, style({ opacity: 0, transform: 'translateY(-4px)' }))
  ])
]);
